import './SelectableCaddie.scss';

import React from 'react';
import {ClubCaddie} from "../../../services/api/ClubCaddieService";
import {Button} from "react-bootstrap";
import Avatar from "../../../components/Avatar";

interface Props {
    caddie: ClubCaddie
    onSelected: () => void
}

const SelectableCaddie = ({caddie, onSelected}: Props) => {

    return (
        <div className={"selectableCaddie_container"}>
            <div>
                <Avatar user={caddie.userId} size={'smd'} round={false} style={{ borderRadius: '5' }} />
            </div>
            <div className={"selectableCaddie_informationContainer"}>
                <div>
                    <span className={"selectableCaddie_caddieName"}>{caddie.displayName}</span>
                </div>
                <div className={"selectableCaddie_buttonRow"}>
                    <Button variant={'primary'} onClick={onSelected} className={"selectableCaddie_btn"}>
                        SELECT
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default SelectableCaddie;